import { createPlatePlugin } from 'platejs/react'
import { PathApi } from 'platejs'

export function parseFigmaUrl(url: string): { fileKey: string; nodeId: string | null } | null {
    try {
        const parsed = new URL(url)
        if (!parsed.hostname.includes('figma.com')) return null
        const parts = parsed.pathname.split('/').filter(Boolean)
        const typeIdx = parts.findIndex(p => ['design', 'file', 'proto'].includes(p))
        if (typeIdx === -1 || typeIdx + 1 >= parts.length) return null
        const fileKey = parts[typeIdx + 1]
        if (!fileKey) return null
        const rawNodeId = parsed.searchParams.get('node-id')
        const nodeId = rawNodeId ? rawNodeId.replace(/-/g, ':') : null
        return { fileKey, nodeId }
    } catch {
        return null
    }
}

export const FigmaPlugin = createPlatePlugin({
    key: 'figma',
    node: { type: 'figma', isElement: true, isVoid: true },
    extendEditor: ({ editor }) => {
        const e = editor as any
        const insertData = e.insertData as (data: DataTransfer) => void
        e.insertData = (data: DataTransfer) => {
            const text = data.getData('text/plain')?.trim()
            if (text && parseFigmaUrl(text)) {
                const blockEntry = editor.api.block()
                if (blockEntry) {
                    const [block, blockPath] = blockEntry
                    const isEmpty = editor.api.isEmpty(block as any)
                    if (isEmpty) {
                        editor.tf.withoutNormalizing(() => {
                            editor.tf.removeNodes({ at: blockPath })
                            editor.tf.insertNodes(
                                [
                                    { type: 'figma', url: text, children: [{ text: '' }] } as any,
                                    { type: 'p', children: [{ text: '' }] } as any,
                                ],
                                { at: blockPath }
                            )
                        })
                    } else {
                        const afterPath = PathApi.next(blockPath)
                        editor.tf.insertNodes(
                            [
                                { type: 'figma', url: text, children: [{ text: '' }] } as any,
                                { type: 'p', children: [{ text: '' }] } as any,
                            ],
                            { at: afterPath }
                        )
                    }
                } else {
                    editor.tf.insertNodes([
                        { type: 'figma', url: text, children: [{ text: '' }] } as any,
                        { type: 'p', children: [{ text: '' }] } as any,
                    ])
                }
                return
            }
            insertData(data)
        }
        return editor
    },
})
